export default [
    {
        path: "/aoms",
        name: "aoms__root__",
        redirect: {
            name: "aoms-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "aoms",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "aoms-index",
                component: () => import("@/views/aoms/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/aoms/org",
        name: "aoms-org",
        component: () => import("@/layouts/default.vue"),
        meta: {
            title: "组织管理",
            icon: "mkt-organization",
            parent: "aoms",
        },
        children: [
            {
                path: "",
                name: "aoms-org-index",
                component: () => import("@/views/aoms/org/index.vue"),
                meta: {
                    title: "组织管理",
                    icon: "mkt-organization",
                },
            },
        ],
    },
    {
        path: "/aoms/permission",
        name: "aoms-permission",
        component: () => import("@/layouts/default.vue"),
        meta: {
            title: "权限配置",
            icon: "cms-account-permission",
            parent: "aoms",
        },
        children: [
            {
                path: "",
                name: "aoms-permission-index",
                component: () => import("@/views/aoms/conf/permission.vue"),
                meta: {
                    title: "权限配置",
                    icon: "cms-account-permission",
                },
            },
        ],
    },
    {
        path: "/aoms/message",
        name: "aoms-message",
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "aoms-message-index",
        },
        alwaysShow: true,
        meta: {
            title: "消息中心",
            icon: "cms-message",
            parent: "aoms",
        },
        children: [
            {
                path: "message",
                name: "aoms-message-index",
                component: () => import("@/views/aoms/message/index.vue"),
                meta: {
                    title: "私信管理",
                    icon: "cms-msg-message",
                },
            },
            {
                path: "email",
                name: "aoms-message-email",
                component: () => import("@/views/aoms/message/email/index.vue"),
                meta: {
                    title: "邮件管理",
                    icon: "cms-email",
                },
            },
            {
                path: "email-detail",
                name: "aoms-message-email-detail",
                component: () => import("@/views/aoms/message/email/detail.vue"),
                hidden: true,
                meta: {
                    title: "发送邮件",
                    activeMenu: "/aoms/message/email",
                },
            },
            {
                path: "email-template",
                name: "aoms-message-email-template",
                component: () => import("@/views/aoms/message/email/template.vue"),
                hidden: true,
                meta: {
                    title: "邮件模板",
                    activeMenu: "/aoms/message/email",
                },
            },
            {
                path: "email-template-detail/:slug?",
                name: "aoms-message-email-template-detail",
                component: () => import("@/views/aoms/message/email/template-detail.vue"),
                hidden: true,
                meta: {
                    title: "邮件模板详情",
                    activeMenu: "/aoms/message/email",
                },
            },
            {
                path: "template",
                name: "aoms-message-template",
                component: () => import("@/views/aoms/message/template.vue"),
                hidden: true,
                meta: {
                    title: "私信模板",
                    activeMenu: "/aoms/message/message",
                },
            },
            {
                path: "template-detail/:id(\\d+)?",
                name: "aoms-message-template-detail",
                component: () => import("@/views/aoms/message/template-detail.vue"),
                hidden: true,
                meta: {
                    title: "私信模板详情",
                    activeMenu: "/aoms/message/message",
                },
            },
        ],
    },
];
